module.exports = __webpack_public_path__ + "static/media/tip_of_the_jetty.c47d49b6.jpg";